import {scaffolderPlugin} from '@backstage/plugin-scaffolder';
import {createScaffolderFieldExtension} from '@backstage/plugin-scaffolder-react';
import {FormFieldBlueprint, createFormField} from '@backstage/plugin-scaffolder-react/alpha';
import {ProjectNameValidatorField} from './ProjectNameField';
import {schema} from './schema';

const projectNameValidatorFormField = createFormField({
  name: 'ProjectNameValidatorExtension',
  component: ProjectNameValidatorField as any,
  schema: schema as any,
});

export const ProjectNameValidatorExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ProjectNameValidatorExtension',
    component: ProjectNameValidatorField,
    schema,
  }),
);

export const projectNameValidatorFieldExtension = FormFieldBlueprint.make({
  name: 'project-name-validator-extension',
  params: {
    field: async () => projectNameValidatorFormField,
  },
});
